export default "__VITE_ASSET__CMzaa3fS__"